import {verify} from './logger'
import {TitleWithId} from './types'

export function getTitleById<ID extends string>(id: ID, array: Array<TitleWithId<ID>>): string {
  const item = verify(array.find(x => x.id === id), `TitleWithId agreement was violated. Id: "${id}" wasn't found.`)
  return item ? item.title : ''
}